
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a-new-era-of-cool",
      function () {
        return require("private-next-pages/a-new-era-of-cool/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a-new-era-of-cool"])
      });
    }
  